
import { Options, Vue } from 'vue-class-component';
import { mapGetters } from 'vuex';
import store from '@/store';
import config from '@/config.json';

@Options({
  computed: {
    ...mapGetters(['isAuthenticated', 'getJsonData', 'getTheme', 'getLocale']),
    jsonData() {
      const jsonData = (this as any).getJsonData;
      const jsonDataWithBreaks = JSON.stringify(jsonData).replace(/\\n/g, '<br>');
      return JSON.parse(jsonDataWithBreaks);
    },
    showRegisterButton() {
      return config.showRegisterButton;
    },
    showLangSwitcher() {
      return config.showLangSwitcher;
    },
    isLight() {
      return (this as any).getTheme === 'light';
    },
    isRu() {
      return (this as any).getLocale === 'ru';
    }
  },
  methods: {
    openAuth() {
      store.commit('SET_AUTH_MODAL', { visible: true, mode: 'register' });
    },
    toggleLocale() {
      const self = this as any;
      store.commit('SET_LOCALE', self.getLocale === 'ru' ? 'en' : 'ru');
    },
    toggleTheme() {
      const self = this as any;
      store.commit('SET_THEME', self.getTheme === 'light' ? 'dark' : 'light');
    }
  }
})
export default class SideMenu extends Vue {}
